var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppDocs = function SvgAppDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.07 9.12l.93.5-9.5 5.1L0 9.62l.93-.5 8.57 4.6 8.57-4.6zm0 3l.93.5-9.5 5.1-9.5-5.1.93-.5 8.57 4.6 8.57-4.6zM9.5 1.5L19 6.62l-9.5 5.1L0 6.62 9.5 1.5zm0 1l7.7 4.12-7.7 4.1-7.7-4.1L9.5 2.5z",
    fillRule: "evenodd"
  })));
};
export default SvgAppDocs;